const selectPropertiesFromModels = ({ model, properties }) => model.values.map(({ id, propertyId }) => {
  const prop = properties.find(p => p.id === propertyId)
  const value = prop.values.find(v => v.id === id)
  return {
    title: prop.name,
    value: `${value.value} ${prop.unit}`,
  }
})

export default selectPropertiesFromModels
